export enum DefaultLangEnum {
    English = 'en',
    Spanish = 'es'
}